export default {
    url: '/edit/:planningGroupId',
    template: `
        <div class="heading01">
            <h2>{{ vm.planningGroup.name }}</h2>
        </div>
        <ul class="tabs01">
            <li>
                <a ng-class="{ active: vm.step==1 }"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({ id: vm.course.id, planningGroupId: vm.planningGroup.id, saveErrors: null })"
                >{{ 'planningGroup.General data' | translate }}</a>
            </li>
            <li>
                <a ng-class="{ active: vm.step==2 }"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.targets({ id: vm.course.id, planningGroupId: vm.planningGroup.id })"
                >{{ 'planningGroup.Targets' | translate }}</a>
            </li>
            <li>
                <a ng-class="{ active: vm.step==3 }"
                    ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.employee({ id: vm.course.id, planningGroupId: vm.planningGroup.id })"
                >{{ 'planningGroup.Employees' | translate }}</a>
            </li>
        </ul>
        <courses-courses-edit-occurrence-automated-planning-group-generation-progress
            planning-group="vm.planningGroup"
        ></courses-courses-edit-occurrence-automated-planning-group-generation-progress>
        <ui-view></ui-view>
    `,
    abstract: true,
    resolve: {
        planningGroup ($stateParams, AutomatedPlanningGroupResource) {
            return AutomatedPlanningGroupResource.get({
                id: $stateParams.planningGroupId,
                expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,' +
                    'planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions'
            }).$promise;
        }
    },
    controller ($scope, planningGroup, course) {
        this.$scope = $scope;
        this.course = course;
        this.planningGroup = planningGroup;
        this.$scope.$on('planning-group:update', (event, updatedGroup) => {
            this.planningGroup = updatedGroup;
        });
        // the member list shows the latest enrollments once the run that made them has finished
        this.$scope.$on('planning-group:generation-finished', () => {
            this.$scope.$broadcast('employee-list:refresh');
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/edit/index.js